import { createModule } from '../createModule';

export const payment = createModule('payment');